<template>
    <v-tabs color="primary"  v-model="activeTabId">
        <v-tab>General</v-tab>
        <v-tab>GEOS</v-tab>
        <v-tab-item :key="`offer-${item.data.id}-general`">
            <v-container fluid>
<!--                {{JSON.stringify(item)}}-->
                <v-row align="center">
                    <v-col cols="6" sm="6" class="py-0">
                                <v-text-field class="text-filed-custom" label="Id" readonly :value="item.data.id"></v-text-field>
                                <v-text-field class="text-filed-custom" label="Name" readonly hide-details :value="item.data.name"></v-text-field>
                                <v-text-field class="text-filed-custom" label="Advertiser" readonly hide-details :value="item.data.advertiser"></v-text-field>
                                <v-text-field class="text-filed-custom" label="Currency" readonly hide-details :value="item.data.currency"></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6" class="py-0">
                                <v-text-field class="text-filed-custom" label="PayIn" readonly :value="item.data.price"></v-text-field>
                                <v-text-field class="text-filed-custom" label="PayOut" readonly :value="item.data.payout"></v-text-field>
                                <v-text-field class="text-filed-custom" label="Margin Type" readonly :value="item.data.marginType"></v-text-field>
                                <v-text-field class="text-filed-custom" label="Margin Percent" readonly :value="item.data.marginPercent"></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-tab-item>
        <v-tab-item :key="`offer-${item.data.id}-geos`">
            <v-container fluid>
                <v-data-table
                        :headers="headers"
                        :items="countries"
                        class="elevation-1"
                >
                </v-data-table>
            </v-container>
        </v-tab-item>
    </v-tabs>

</template>

<script>
    import {mapState} from 'vuex'
    export default {
        props: {
            item: {
                type: Object
            }
        },
        components: {},
        async mounted() {
          if (!this.item.data.geos.length && this.item.data.payout && this.item.data.price) {
            this.countries = [{
              code: "WW",
              name: "Worldwide",
              payout: this.item.data.payout,
              price: this.item.data.price
            }];
          } else {
            this.countries = this.item.data.geos;
          }
        },
        watch: {},
        methods: {},
        computed:{
            ...mapState('user', ['user']),
        },
        name: "ProgramCard",

        data() {
            return {
                activeTabId: 0,
                headers:[
                    { text: "Code", value: "code" },
                    { text: "Name", value: "name" },
                    { text: "Payout", value: "payout" },
                    { text: "Price", value: "price" },
                ],
                countries: []
            }
        }
    }
</script>

<style scoped lang="sass">
    .text-filed-custom
        height: 56px !important
</style>
